import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { MatFormFieldModule } from "@angular/material/form-field";
import {
  MatTabsModule,
  MatTabsConfig,
  MAT_TABS_CONFIG,
} from "@angular/material/tabs";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { CoreService } from "../../services/core.service";
import { MatIconModule } from "@angular/material/icon";
import { SocialAiSiteTableComponent } from "../../components/tables/social-ai-site-table/social-ai-site-table.component";
import { SocialAiComponent } from "../social-ai/social-ai.component";
import { SocialAiPlatformsTableComponent } from "../../components/tables/social-ai-platforms-table/social-ai-platforms-table.component";
import { SocialAiQueueTableComponent } from "../../components/tables/social-ai-queue-table/social-ai-queue-table.component";
import { SocialAiStoryTableComponent } from "../../components/tables/social-ai-story-table/social-ai-story-table.component";

@Component({
  selector: "app-social-ai-settings",
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    SocialAiSiteTableComponent,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    SocialAiComponent,
    SocialAiPlatformsTableComponent,
    SocialAiQueueTableComponent,
    SocialAiStoryTableComponent,
  ],
  templateUrl: "./social-ai-settings.component.html",
  styleUrl: "./social-ai-settings.component.scss",
  providers: [
    {
      provide: MAT_TABS_CONFIG,
      useValue: {
        animationDuration: "900ms",
        disablePagination: false,
      } as MatTabsConfig,
    },
  ],
})
export class SocialAiSettingsComponent implements OnInit {
  selectedCompanyId: string | null = null;
  companies: any[] = [];
  selectedIndex: number = 0;
  companyID: number | null = null;
  tiktokPlatformId: string | null = null;
  tiktokSiteId: string | null = null;

  tabs = [
    { name: "Sites", icon: "web" },
    { name: "Social Platforms", icon: "share" },
    { name: "Scheduler", icon: "schedule" },
    { name: "Posting Queue", icon: "queue" },
    { name: "Manage Story Posts", icon: "manage_history" },
  ];

  constructor(
    private coreService: CoreService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const storedCompanyId = (this.companyID =
      this.coreService.user?.companyID || 0);

    if (storedCompanyId) {
      this.selectedCompanyId = storedCompanyId;
    } else {
      this.selectedCompanyId = null;
    }

    const oauthResult =
      this.route.snapshot.queryParamMap.get("fb_oauth");

    if (oauthResult) {
      this.selectedIndex = 1;
      localStorage.setItem("social-ai-tab-index", "1");
      return;
    }

    // Handle TikTok OAuth callback
    const tiktokOauthResult = this.route.snapshot.queryParamMap.get("tiktok_oauth");
    const platformId = this.route.snapshot.queryParamMap.get("platform_id");
    const siteId = this.route.snapshot.queryParamMap.get("site_id");

    if (tiktokOauthResult === 'success' && platformId && siteId) {
      this.selectedIndex = 1; // Switch to Social Platforms tab
      localStorage.setItem("social-ai-tab-index", "1");
      // Store platformId and siteId for passing to child components
      this.tiktokPlatformId = platformId;
      // Store siteId in a way that can be used by child components
      this.tiktokSiteId = siteId;
      return;
    }

    const storedTabIndex = Number(
      localStorage.getItem("social-ai-tab-index")
    );

    if (
      Number.isInteger(storedTabIndex) &&
      storedTabIndex >= 0 &&
      storedTabIndex < this.tabs.length
    ) {
      this.selectedIndex = storedTabIndex;
    }
  }

  onTabChange(index: number) {
    this.selectedIndex = index;
    localStorage.setItem("social-ai-tab-index", index.toString());
  }

  get currentTabLabel(): string {
    const label = this.tabs[this.selectedIndex]?.name || "";

    if (label === "Scheduler") {
      return "Categories & Scheduler";
    }

    if (label === "Manage Story Posts") {
      return "Stories";
    }

    return label;
  }
}